import { ApiService } from '../../../../services/api_service';
import { IDs } from '../../../../helpers/IDs';
import { lazyInject } from '../../../../services/inversify';
import { MehrsprachigkeitMUI } from './MehrsprachigkeitMUI';
import { Navigation } from '../../../Navigation';
import { Navigation as NavigationStructure } from '../../../../main/Navigation';
import * as React from 'react';

interface MehrsprachigkeitNavigationProps extends React.ClassAttributes<any> {
    data: any;
}

interface MehrsprachigkeitNavigationState {
    itemList: any; // { 'list name' : [ items ] }
}

export class MehrsprachigkeitNavigation extends React.Component<MehrsprachigkeitNavigationProps, MehrsprachigkeitNavigationState> {

    constructor(props: any) {
        super(props);
        this.state = {
            itemList: null
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;

    private intern_key2 = 'tab';

    componentDidMount(): void {
        this.init();
    }

    componentDidUpdate(prevProps: Readonly<MehrsprachigkeitNavigationProps>, prevState: Readonly<MehrsprachigkeitNavigationState>, snapshot?: any): void {
        if (this.props.data[IDs.ENT_MEHRSPRACHIGKEIT] && prevProps.data[IDs.ENT_MEHRSPRACHIGKEIT] &&
            this.props.data[IDs.ENT_MEHRSPRACHIGKEIT].length !== prevProps.data[IDs.ENT_MEHRSPRACHIGKEIT].length) {
            this.init();
        }
    }

    init(): void {
        new Navigation(this.props.data, true).getData((naviAdmin: any) => {
            const itemList: any = {};
            new NavigationStructure(this.props.data, this.apiService, null, true).getData((navigation: any) => {
                itemList['Sitemap E-Tool'] = navigation;
            });
            itemList['Sitemap Admin'] = naviAdmin;
            itemList['Sonstige'] = this.getSonstige(itemList);
            this.setState({ itemList });
        });
    }

    getSonstige(itemList: any) {
        const mainList = [...itemList['Sitemap E-Tool'], ...itemList['Sitemap Admin']];
        const mainKeyMap: any = {};
        const loadKeyMap = (arr: Array<any>) => {
            arr.forEach((r: any) => {
                mainKeyMap[r.name] = true;
                if (Array.isArray(r.children)) {
                    loadKeyMap(r.children);
                }
            });
        };
        loadKeyMap(mainList);
        const otherTabs: Array<any> = this.props.data[IDs.ENT_MEHRSPRACHIGKEIT]
            .filter((r: any) => !mainKeyMap[r.intern_key] && r.intern_key2 === this.intern_key2)
            .sort((a: any, b: any) => a.intern_key > b.intern_key ? 1 : a.intern_key < b.intern_key ? -1 : 0)
            .map((r: any) => {
                return { name: r.intern_key };
            });
        return otherTabs;
    }

    render(): JSX.Element {
        if (!this.state.itemList) {
            return <div>Lade ...</div>;
        }
        return (
            <MehrsprachigkeitMUI
                data={this.props.data}
                intern_key2={this.intern_key2}
                itemList={this.state.itemList}
            />
        );
    }
}
